import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from 'react-modal';
import IconTool from '../IconTool';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ModalWindow = function ModalWindow(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      className = _ref.className,
      children = _ref.children;
  var classes = classnames('ptr-Modal', {}, className);
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onAfterOpen: function onAfterOpen() {},
    className: classes,
    overlayClassName: "ptr-ModalOverlay ptr-light",
    onRequestClose: onClose,
    shouldCloseOnOverlayClick: true,
    children: [/*#__PURE__*/_jsx(IconTool, {
      className: "ptr-Modal-closeButton",
      icon: "ri-close",
      onClick: onClose,
      tooltip: {
        text: 'Close',
        position: 'left',
        id: 'ModalTooltip'
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "ptr-Modal-content",
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    })]
  });
};

ModalWindow.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
var setAppElement = Modal.setAppElement;
export { ModalWindow as default, setAppElement };